<template>
    <vs-popup title="Generar ficha de pago">
      <h6>La ficha de pago tiene una vigencia de 30 días.</h6>
      <vs-input
          class="w-full"
          label="Por favor indica la fecha límite (en la que terminarán los 30 días)"
          v-model="due_date"></vs-input>
        <div class="mt-6">
            <vs-button color="dark" @click="hideDialog()">Cerrar</vs-button>
            <vs-button @click="send()">Generar</vs-button>
        </div>
    </vs-popup>
</template>

<script>
export default {
    props: ["project_id"],
    data() {
        return {
            due_date: null
        }
    },

    methods: {
        async send() {
            try {
                let res = await axios.post(`/api/project/${this.project_id}/new_card_payment`, {
                    "due_date": this.due_date
                });
                this.$emit("onGenerated", res);
                swal("Ok!", "Se ha generado una nueva ficha", "success");
            } catch (ex) {
                swal("Upss!", "Hubo un error al generar la ficha de pago", "error")
            }
        },
        show() {
            $("#modal_payment_card").modal("show")
        }
    }
}
</script>
